import { serviceNotifications } from "./serviceNotifications";
import { WSNotificationResponse } from "../../modules/Dashboard/components/Notifications";

export const patchDismissNotification = async (
  id: string
): Promise<WSNotificationResponse> => {
  const { data } = await serviceNotifications.patch(`/in-app/${id}/dismiss`);

  return data;
};
